/// <amd-module name="Feed/Legacy/Helpers/PivotBarActionGetter" />
import { IPivotBarAction } from "VSSUI/PivotBar";
import { IVssIconProps } from "VSSUI/VssIcon";

import { IPackageCommand } from "Feed/Legacy/Types/IPackageCommand";
import * as PackageResources from "Feed/Common/Resources";

export class PivotBarActionsGetter {
    public GetPivotBarActions(packageCommands: IPackageCommand[]): IPivotBarAction[] {
        return this.mapToPivotBarAction(packageCommands);
    }

    private mapToPivotBarAction(packageCommands: IPackageCommand[]): IPivotBarAction[] {
        if (packageCommands == null) {
            return null;
        }

        const actions: IPivotBarAction[] = [];

        packageCommands.map((command: IPackageCommand) => {
            const name: string = command.displayText;

            actions.push({
                key: command.id,
                name,
                important: command.id.indexOf("-all") === -1 ? true : false, // to the context menu if command is for all versions.
                iconProps: {
                    iconName: command.icon
                } as IVssIconProps,
                onClick: command.actionMethod,
                disabled: command.disabled
            });
        });
        return actions;
    }
}
